const LOCAL_STORAGE_KEY = 'recentL2Categories';
const MAX_RECENT_L2S = 2;

type TRecentL2Entry = {
  l1CategoryId: number;
  l2CategoryIds: number[];
};

export const getRecentL2Categories = (l1CategoryId: number): number[] => {
  if (typeof localStorage === 'undefined') return [];
  try {
    const storageItem = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!storageItem) return [];
    const entries: TRecentL2Entry[] = JSON.parse(storageItem);
    if (!Array.isArray(entries)) return [];
    const entry = entries.find((e) => e.l1CategoryId === l1CategoryId);
    return entry?.l2CategoryIds || [];
  } catch {
    return [];
  }
};

export const storeRecentL2Categories = (l1CategoryId: number, l2CategoryIds: number[]): void => {
  if (typeof localStorage === 'undefined') return;
  if (l2CategoryIds.length === 0) return;

  try {
    const storageItem = localStorage.getItem(LOCAL_STORAGE_KEY);
    let entries: TRecentL2Entry[] = storageItem ? JSON.parse(storageItem) : [];
    if (!Array.isArray(entries)) entries = [];

    const existingIndex = entries.findIndex((e) => e.l1CategoryId === l1CategoryId);
    const existingIds = existingIndex >= 0 ? entries[existingIndex].l2CategoryIds : [];

    const mergedIds = [...new Set([...l2CategoryIds, ...existingIds])].slice(0, MAX_RECENT_L2S);

    if (existingIndex >= 0) {
      entries[existingIndex].l2CategoryIds = mergedIds;
    } else {
      entries.push({ l1CategoryId, l2CategoryIds: mergedIds });
    }

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(entries));
  } catch {
    return;
  }
};
